export default __webpack_public_path__ + "static/media/sort.bd00af35.svg";